import LegalPage, { Section, P, UL } from "@/components/legal/LegalPage";
import { SITE } from "@/lib/siteConfig";

/**
 * BORRADOR. Redactado siguiendo los elementos que pide el artículo 16 de la
 * LFPDPPP, pero debe revisarlo un abogado y hay que llenar los datos de SITE
 * (responsable, domicilio, correo para derechos ARCO) antes de publicarlo.
 */
export default function PrivacyPage() {
    return (
        <LegalPage
            title="Aviso de privacidad"
            intro="Aquí explicamos qué datos personales recabamos, para qué los usamos y cómo puedes controlarlos."
            updatedAt={SITE.legalUpdatedAt}
        >
            <Section n={1} title="Quién es responsable de tus datos">
                <P>
                    {SITE.legalName}, con domicilio en {SITE.address}, es
                    responsable del tratamiento de los datos personales que se
                    recaban a través de {SITE.domain}, conforme a la Ley Federal
                    de Protección de Datos Personales en Posesión de los
                    Particulares (LFPDPPP), su Reglamento y sus Lineamientos.
                </P>
            </Section>

            <Section n={2} title="Qué datos recabamos">
                <P>Según cómo uses la plataforma, podemos recabar:</P>
                <UL
                    items={[
                        <>
                            <strong>De identificación y contacto:</strong>{" "}
                            nombre, correo electrónico, teléfono y, si inicias
                            sesión con Google, la foto de tu perfil.
                        </>,
                        <>
                            <strong>De entrega:</strong> calle, número, colonia,
                            código postal, ciudad, estado y referencias, cuando
                            realizas una compra con envío.
                        </>,
                        <>
                            <strong>De tu tienda, si vendes:</strong> nombre
                            comercial, descripción, logotipo, dirección de
                            origen del envío y clave de producto del catálogo
                            del SAT.
                        </>,
                        <>
                            <strong>De tus operaciones:</strong> pedidos,
                            montos, estados de pago y de envío.
                        </>,
                        <>
                            <strong>Técnicos:</strong> dirección IP, tipo de
                            navegador y páginas visitadas, con fines de
                            seguridad y estadística.
                        </>,
                    ]}
                />
                <P>
                    <strong>No almacenamos los datos completos de tu tarjeta.</strong>{" "}
                    Los pagos se procesan directamente con nuestro proveedor de
                    pagos, que cumple con el estándar PCI DSS; nosotros solo
                    conservamos el identificador de la transacción y su estado.
                </P>
                <P>
                    No recabamos datos personales sensibles (origen racial,
                    estado de salud, creencias, preferencia sexual u
                    equivalentes).
                </P>
            </Section>

            <Section n={3} title="Para qué usamos tus datos">
                <P>Finalidades necesarias para darte el servicio:</P>
                <UL
                    items={[
                        "Crear y administrar tu cuenta e iniciar sesión de forma segura.",
                        "Procesar los pedidos, cobros y, en su caso, reembolsos.",
                        "Cotizar el envío, generar la guía y darle seguimiento hasta la entrega.",
                        "Enviarte correos transaccionales: confirmación de compra, avisos de envío y cambios en tus pedidos.",
                        "Atender tus dudas, reportes o solicitudes de soporte.",
                        "Prevenir fraudes y usos indebidos de la plataforma.",
                        "Cumplir con obligaciones legales y fiscales.",
                    ]}
                />
                <P>
                    Finalidades adicionales, que no son necesarias y a las que
                    puedes oponerte en cualquier momento: enviarte novedades del
                    producto, consejos para vender y encuestas de satisfacción.
                    Negarte a estas no afecta el uso del servicio.
                </P>
            </Section>

            <Section n={4} title="Con quién compartimos tus datos">
                <P>
                    Para poder operar, compartimos los datos estrictamente
                    necesarios con proveedores que actúan por cuenta nuestra:
                </P>
                <UL
                    items={[
                        "El procesador de pagos, para cobrar y, en su caso, reembolsar.",
                        "Las empresas de paquetería, para cotizar, generar la guía y entregar tu pedido.",
                        "El proveedor de correo electrónico, para enviarte los avisos de tus pedidos.",
                        "El proveedor de infraestructura donde se aloja la plataforma.",
                        "La herramienta de analítica web, con datos de navegación.",
                    ]}
                />
                <P>
                    Cuando compras en una tienda, el Vendedor recibe tus datos
                    de contacto y de entrega para poder cumplir con el pedido.
                </P>
                <P>
                    Estas transferencias son las previstas en el artículo 37 de
                    la LFPDPPP y no requieren tu consentimiento. Fuera de estos
                    casos y de los que exija una autoridad competente, no
                    vendemos ni cedemos tus datos a terceros.
                </P>
            </Section>

            <Section n={5} title="Tus derechos ARCO">
                <P>
                    Tienes derecho a <strong>acceder</strong> a tus datos,{" "}
                    <strong>rectificarlos</strong> si son inexactos,{" "}
                    <strong>cancelarlos</strong> cuando consideres que no se
                    requieren y <strong>oponerte</strong> a su uso para fines
                    específicos. También puedes revocar el consentimiento que
                    nos hayas otorgado.
                </P>
                <P>
                    Para ejercerlos, escribe a{" "}
                    <span className="font-medium text-[#1A1A1A]">
                        {SITE.privacyEmail}
                    </span>{" "}
                    indicando tu nombre, un medio para contactarte, los
                    documentos que acrediten tu identidad y una descripción
                    clara de lo que solicitas. Responderemos en un plazo máximo
                    de 20 días hábiles y, de resultar procedente, la haremos
                    efectiva dentro de los 15 días hábiles siguientes.
                </P>
                <P>
                    Algunos datos deben conservarse por obligaciones fiscales o
                    contables aun después de que cierres tu cuenta; en esos
                    casos se bloquean y solo se usan para cumplir con la ley.
                </P>
            </Section>

            <Section n={6} title="Cookies y tecnologías similares">
                <P>
                    Usamos almacenamiento local del navegador para mantener tu
                    sesión iniciada y recordar el contenido de tu carrito, y una
                    herramienta de analítica que nos ayuda a entender cómo se
                    usa el sitio de forma agregada. Puedes borrar o bloquear
                    estas tecnologías desde la configuración de tu navegador,
                    aunque algunas funciones podrían dejar de operar
                    correctamente.
                </P>
            </Section>

            <Section n={7} title="Seguridad y conservación">
                <P>
                    Aplicamos medidas técnicas y organizativas para proteger tus
                    datos: cifrado del sitio con HTTPS, contraseñas guardadas de
                    forma irreversible, sesiones con expiración y acceso
                    restringido al personal que lo necesita. Conservamos tus
                    datos mientras tengas una cuenta activa y por los plazos que
                    exija la normativa aplicable.
                </P>
            </Section>

            <Section n={8} title="Cambios a este aviso">
                <P>
                    Podemos actualizar este aviso por cambios en el servicio o
                    en la ley. La versión vigente estará siempre publicada en
                    esta página, con la fecha de su última actualización.
                </P>
            </Section>

            <Section n={9} title="Autoridad">
                <P>
                    Si consideras que tu derecho a la protección de datos ha
                    sido vulnerado, puedes acudir al Instituto Nacional de
                    Transparencia, Acceso a la Información y Protección de Datos
                    Personales (INAI).
                </P>
                <P>
                    Para cualquier duda sobre este aviso, escríbenos a{" "}
                    <span className="font-medium text-[#1A1A1A]">
                        {SITE.privacyEmail}
                    </span>
                    .
                </P>
            </Section>
        </LegalPage>
    );
}
